
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/holidays/hotels",
      function () {
        return require("private-next-pages/holidays/hotels/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/holidays/hotels"])
      });
    }
  